import React, { useState, useEffect } from "react";

const GROUP_COUNTRY_CODES = [
  "US",
  "UM",
  "CA",
  "CH",
  "BR",
  "MX",
  "AR",
  "CO",
  "CL",
  "PE",
  "EC",
  "VE",
  "DO",
  "GT",
  "PA",
  "CR",
  "UY",
  "BO",
  "PY",
  "SV",
  "HN",
  "TT",
  "JM",
  "BS",
  "NI",
  "HT",
  "BB",
  "SR",
  "GY",
  "BZ",
  "LC",
  "AG",
  "GD",
  "KN",
  "VC",
  "DM",
  "RU",
  "AZ",
  "AM",
  "BY",
  "KZ",
  "KG",
  "MD",
  "TJ",
  "UZ",
  "TM",
  "GE",
  "UA",
  "CN",
];

const useLocalization = () => {
  const [currentLocale, setCurrentLocale] = useState("us");
  if (process.env.LOCALIZATION_SWITCH !== "true") return currentLocale;

  const getLocation = () => {
    if (window.countryCode) {
      !GROUP_COUNTRY_CODES.includes(window.countryCode) &&
        setCurrentLocale("eu");
    } else {
      setTimeout(getLocation, 100);
    }
  };

  useEffect(() => {
    getLocation();
  }, []);

  return currentLocale;
};

export default useLocalization;
